import { gql } from '@apollo/client';

import { ProfessorActivity } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface DeleteActivityMutationVariables {
  courseId: string;
  activityId: string;
}

export interface DeleteActivityMutationResult {
  activity: ProfessorActivity;
}

export const deleteActivityMutation = gql`
  mutation DeleteActivity($courseId: String!, $activityId: String!) {
    activity(courseId: $courseId, activityId: $activityId)
      @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}", method: "DELETE") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
